import Backbone from "backbone";
import {events} from "../../commun/backbone/decorators";

@events({
            'click .selected_language' : '_onClickSelectedLanguage',
            'dbclick .selected_language' : '_onDblClickSelectedLanguage',
            'click ul.available_languages .language' : '_onClickLanguage',
        })
class LoginBaseView extends Backbone.View
{
    initialize(options)
    {
        super.initialize(options);

        this.timeoutid = null;
        this.listenTo(this.model, 'load-language', (language) => this._onLoadLanguage(language))
        this.listenTo(this.model, 'hide-languages', (localeToKeep) => this._hideLanguages(localeToKeep))
        this.listenTo(this.model, 'show-languages', () => this._showLanguages())
        this.listenTo(this.model, 'reset-alert', () => this._resetAlertMessage())
        this.listenTo(this.model, 'set-alert-warning', (message) => this._setWarningMessage(message))
    }

    render()
    {
        this.$loginInfo = $('#login-info');
        this.$loginAlert = $('#login-alert');
        this.$loginWarning = $('#login-warning');
        this.$loginMessConteneur = $('#login-alert-container');

        this.$availableLanguages = $(".available_languages");
        this.$selectedLanguage = $('.selected_language');
        this.$locale = $("#m_sLocale");

        this._renderLanguage();

        const that = this;
        $(document).click(function(e) {
            that._onClickDocument(e);
        });
    }
    _renderLanguage()
    {
        const languages = this.model.get('languages');
        if(!languages.length || languages.length === 1) {
            $(".languages").remove();
        }
        this.model.initLanguage();
    }
    _onLoadLanguage(language)
    {
        if (!language){
            return ;
        }
        this.$selectedLanguage.html('<img src="' + this.model.get('base_image_url') + language.short + '.png" alt=""/>');
        this.$locale.val(language.code);

        $('html').attr('lang', language.short);
        $('input[placeholder]').each(function(){
            const attr = $(this).attr('data-placeholder-'+language.short);
            // For some browsers, `attr` is undefined; for others,
            // `attr` is false.  Check for both.
            if ((typeof attr !== 'undefined') && (attr !== false)) {
                $(this).attr('placeholder', attr);
            }
        });

        const $title = $('head > title');
        const attr = $title.attr('data-'+language.short);
        // For some browsers, `attr` is undefined; for others,
        // `attr` is false.  Check for both.
        if ((typeof attr !== 'undefined') && (attr !== false)) {
            $title.text(attr);
        }
    }

    _onClickDocument(event)
    {
        const languageIsVisible = this.model.get('language_is_visible');
        if (!languageIsVisible){
            return ;
        }
        if (event)
        {
            const selectedLanguage = this.$selectedLanguage[0];
            if (
                (event.target === selectedLanguage) ||
                !languageIsVisible ||
                $(event.target).parents().toArray().find(function (el)
                                                         {
                                                             return el === selectedLanguage
                                                         })
            )
            {
                return;
            }
        }
        this.$availableLanguages.toggle();
        this.model.set('language_is_visible', !languageIsVisible);
    }

    _onDblClickSelectedLanguage(event)
    {
        event.preventDefault();
    }

    _onClickSelectedLanguage(event)
    {
        this.$availableLanguages.toggle();
        const languageIsVisible = this.model.get('language_is_visible');
        this.model.set('language_is_visible', !languageIsVisible);
    }

    _onClickLanguage(event)
    {
        let $target = $(event.target);
        if (!$target.is('li'))
            $target = $target.parent();

        const codeLanguage =$target.data('language-code');
        this.model.loadLanguage(codeLanguage);
    }

    _resetAlertMessage()
    {
        this.$loginMessConteneur.addClass('d-none');
        this.$loginInfo.addClass('d-none');
        this.$loginAlert.addClass('d-none');
        this.$loginWarning.addClass('d-none');
    }
    _setAlertMessage(message)
    {
        this.$loginAlert.html(message);
        this.$loginAlert.removeClass('d-none');
        this.$loginMessConteneur.removeClass('d-none');
    }
    _setInfoMessage(message)
    {
        this.$loginInfo.html(message);
        this.$loginInfo.removeClass('d-none');
        this.$loginMessConteneur.removeClass('d-none');
    }
    _setWarningMessage(message)
    {
        this.$loginWarning.html(message);
        this.$loginWarning.removeClass('d-none');
        this.$loginMessConteneur.removeClass('d-none');
    }

    _hideLanguages(principalToKeep)
    {
        if (principalToKeep === 0){
            this.$selectedLanguage.addClass('d-none');
        }
        else {
            this.$availableLanguages.find('li').each(function(){
                const $this = $(this);
                if ((parseInt($this.data('language-code')) & 0x3ff) !== principalToKeep){
                    $this.addClass('d-none');
                }
            });
        }
    }
    _showLanguages()
    {
        this.$selectedLanguage.removeClass('d-none');
        this.$availableLanguages.find('li').removeClass('d-none');
    }

}
export default LoginBaseView;